import React from 'react'
import Work from '../components/technology/Work';

const Technology = () => {
  return (
    <div>
        <section className="bg-image pt-25 pb-25">
            <div className="container">
                <h2 className="Banner-Title">Technologies</h2>
            </div>
        </section>
        <Work/>
    </div>
  )
}

export default Technology